import { AdultsPickerModeEnum } from './adults-picker.enum'

export const getAdultsPickerClassNameByEnum = (
  adultsPickerMode: AdultsPickerModeEnum,
): string => {
  switch (adultsPickerMode) {
    case AdultsPickerModeEnum.HOUSE_SEARCH:
      return 'houseSearch'
    default:
      return 'default'
  }
}
